<template>
  <table ref="table">
    <slot />
  </table>
</template>

<script setup lang="ts">
const table = useTemplateRef('table');

onMounted(() => {
  setLabels();
});

function setLabels(){
  const ths = table.value!.querySelectorAll('th');
  const trs = table.value!.querySelectorAll('tr');
  for (const tr of trs) {
    for (const cell of tr.cells) {
      const th = ths[cell.cellIndex];
      cell.dataset.label = th.textContent || '';
    }
  }
}
</script>

<style scoped>
table {
  border-collapse: collapse;
  border-radius: var(--border-r-sm);
  overflow: hidden;
}
table :deep(tr) {
  text-align: left;
}
table :deep(td) {
  border: 1px solid #ddd;
  padding: var(--space-2);
}
table :deep(th) {
  padding: var(--space-2);
  text-align: left;
  background-color: rgb(var(--v-theme-primary));
  color: white;
  font-weight: normal;
}
table :deep(tr:nth-child(even)) {
  background-color: #f2f2f2;
}
table :deep(tr:hover) {
  background-color: #ddd;
}

@media (max-width: 850px) {
  table :deep(thead) {
    display: none;
  }
  table :deep(tr) {
    display: block;
    margin-bottom: var(--space-6);
  }
  table :deep(td) {
    display: flex;
    padding-inline: var(--space-2);
  }
  table :deep(td::before) {
    content: attr(data-label);
    font-weight: bold;
    min-width: 65px;
    padding-inline-end: var(--space-2);
  }
}
</style>